<template>
  <span class="d-flex flex-row align-items-center" dir="rtl" v-if="rating">
    <!-- <span class="rating-star"> -->
      <img class="rating-star" src="@/assets/icons/rating-star.svg"/>
    <!-- </span> -->
    <span class="rating-value">{{ratingvalue}}</span>
    <span class="rating-count">({{rating.ratings_count || 0}})</span>
  </span>
</template>
<script>
export default {
  props: {
    rating: Object
  },
  computed: {
    ratingvalue() {
      return this.rating.average_rating || 0;
    }
  }
}
</script>
<style scoped>
.rating-container {
  /* display: inline-block; */
  font-size: 14px;
  /* white-space: nowrap; */
}

.rating-count {
  /* display: inline-block; */
  margin-left: 5px;
  font-size: 14px;
  color: #38383b;
}

.rating-value {
  /* display: inline-block; */
  margin-left: 5px;
  font-size: 14px;
}

.rating-star {
  /* display: inline-block; */
  margin-left: 5px;
}
</style>